import { Modal } from "antd";
import AdvertMarketPlace, { AdvertMarketPlaceProps } from "./marketPlace";

const { confirm } = Modal;

type Payload = AdvertMarketPlaceProps['payload'];
type Submit = Parameters<AdvertMarketPlaceProps['onSuccess']>[0];
export default async function openMarketPlace(payload: Payload): Promise<Submit> {
  const cancelBtnId = `market_place_modal_cancel_btn`;
  const closeModal = () => document.getElementById(cancelBtnId)?.click();

  return new Promise((resolve, reject) => {
    confirm({
      title: null,
      content: (
        <AdvertMarketPlace
          onSuccess={(data) => {
            resolve(data);
            closeModal();
          }}
          onCancel={closeModal}
          payload={payload}
        />
      ),
      width: "auto",
      style: {
        inset: 8,
        position: 'absolute',
        maxWidth: "100%",
        padding: 0,
      },
      icon: null,
      className: "open-modal-wp marketplace-modal",
      cancelButtonProps: {
        id: cancelBtnId,
        hidden: true,
      },
      okButtonProps: {
        hidden: true,
      },
      onCancel() {
        reject("Cancel");
      },
    });
  });
}
